import React, { useState, useEffect, useRef } from "react"
import { Box, Heading, Text, HStack, Collapse, Button } from "@chakra-ui/react"
import PostImage from "./PostImage"


export default function PostItem({ title, description, image, company, date, isExperience = false }) {
    const [show, setShow ] = useState(false)
    const [textHeight, setTextHeight] = useState(1)
    const ref = useRef()

    useEffect( () => {
        if (ref.current) {
            setTextHeight(ref.current.clientHeight)
        }
    }, [])

    return (
        <Box bgColor="white" borderRadius={20}>
            <PostImage url={image} />
            <Heading as="h3" pl={10} pr={10} fontSize={[24, 28, 28, 30]} mb={2}>{title}</Heading>
            <HStack pl={10} pr={10} justify="space-between" mb={4}>
                <Heading as="h4" fontSize={[16, 16, 16, 20]} color="gray.500" fontWeight={600}>{company}</Heading>
                <Heading as="h4" fontSize={[14, 14, 14, 18]} color="gray.500" fontWeight={600}>{date}</Heading>
            </HStack>
            <Collapse in={show} startingHeight={textHeight}>
                <Text ref={ref} pl={10} pr={10} pb={10} fontSize={[16, 16, 18, 18]} fontWeight={400}>
                    {!isExperience && !show && (
                        <>
                            {description[0].props.children[0].slice(0, 150)}...
                        </>
                    )}
                    {(isExperience || show) && description}
                    &nbsp;

                    {!isExperience && 
                        <Button variant="link" colorScheme="teal" size="lg" fontSize={[16, 16, 18, 18]} onClick={() => setShow(!show)} _focus={{boxShadow: 'none'}}>
                            Show {show ? "Less" : "More"}
                        </Button>
                    }
                </Text>
            </Collapse>
        </Box>
    )
}